import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { GifImage } from "../mainPage/FAQSearch.style";

export const RandomGifPlayer = ({ gifList, displayDuration = 6000 }) => {
  const [currentGif, setCurrentGif] = useState(gifList[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextGif = gifList[Math.floor(Math.random() * gifList.length)];
      setCurrentGif(nextGif);
    }, displayDuration); // e.g. 6s = approx 2–3 loops depending on GIF length

    return () => clearInterval(interval);
  }, [gifList, displayDuration]);

  return (
    <GifImage
      src={currentGif}
      alt="Animated library helper"
    />
  );
};


// PropTypes validation
RandomGifPlayer.propTypes = {
  gifList: PropTypes.arrayOf(PropTypes.string).isRequired,
  displayDuration: PropTypes.number,
};